import * as React from "react";
import { useCallback, useMemo } from "react";
import { MultiSelect } from "components/common";
import { Col, ControlLabel, FormGroup, HelpBlock, Row } from "components/bootstrap";
import useFieldTypes from "views/logic/fieldtypes/useFieldTypes";
import { ALL_MESSAGES_TIMERANGE } from "views/Constants";
import { getPathnameWithoutId } from "util/URLUtils";
import useSendTelemetry from "logic/telemetry/useSendTelemetry";
import useLocation from "routing/useLocation";
import { TELEMETRY_EVENT_TYPE } from "logic/telemetry/Constants";
import { defaultCompare } from "logic/DefaultCompare";
import AggregationConditionsForm from "./AggregationConditionsForm";
import commonStyles from "../common/commonStyles.css";
const AggregationForm = ({ aggregationFunctions, eventDefinition, validation, onChange }) => {
  var _a, _b, _c;
  const { data: allFieldTypes } = useFieldTypes((_b = (_a = eventDefinition == null ? void 0 : eventDefinition.config) == null ? void 0 : _a.streams) != null ? _b : [], ALL_MESSAGES_TIMERANGE);
  const formattedFields = useMemo(() => allFieldTypes != null ? allFieldTypes : [], [allFieldTypes]);
  const formattedFieldOptions = useMemo(
    () => formattedFields.sort((ftA, ftB) => defaultCompare(ftA.name, ftB.name)).map((fieldType) => ({
      label: `${fieldType.name} \u2013 ${fieldType.value.type.type}`,
      value: fieldType.name
    })),
    [formattedFields]
  );
  const { pathname } = useLocation();
  const sendTelemetry = useSendTelemetry();
  const propagateConfigChange = useCallback(
    (update) => {
      const nextConfig = { ...eventDefinition.config, ...update };
      onChange("config", nextConfig);
    },
    [eventDefinition.config, onChange]
  );
  const handleGroupByChange = useCallback(
    (selected) => {
      const nextValue = selected === "" ? [] : selected.split(",");
      sendTelemetry(TELEMETRY_EVENT_TYPE.EVENTDEFINITION_CONDITION.AGGREGATION_GROUP_BY_FIELD_SELECTED, {
        app_pathname: getPathnameWithoutId(pathname),
        app_section: "event-definition-condition",
        app_action_value: "group-by-field-select",
        selection_count: nextValue.length
      });
      propagateConfigChange({ group_by: nextValue });
    },
    [pathname, propagateConfigChange, sendTelemetry]
  );
  return /* @__PURE__ */ React.createElement("fieldset", null, /* @__PURE__ */ React.createElement("h2", { className: commonStyles.title }, "Aggregation"), /* @__PURE__ */ React.createElement("p", null, "Summarize log messages matching the Filter defined above by using a function. You can optionally group the Filter results by identical field values."), /* @__PURE__ */ React.createElement(Row, null, /* @__PURE__ */ React.createElement(Col, { lg: 7 }, /* @__PURE__ */ React.createElement(FormGroup, { controlId: "group-by" }, /* @__PURE__ */ React.createElement(ControlLabel, null, "Group by Field(s) ", /* @__PURE__ */ React.createElement("small", { className: "text-muted" }, "(Optional)")), /* @__PURE__ */ React.createElement(
    MultiSelect,
    {
      id: "group-by",
      onChange: handleGroupByChange,
      options: formattedFieldOptions,
      ignoreAccents: false,
      value: ((_c = eventDefinition.config.group_by) != null ? _c : []).join(","),
      allowCreate: true
    }
  ), /* @__PURE__ */ React.createElement(HelpBlock, null, "Select fields to group filter results when they have identical values. ", /* @__PURE__ */ React.createElement("b", null, "Example:"), /* @__PURE__ */ React.createElement("br", null), "Assuming you created a Filter with all failed log-in attempts in your network, an alert could be triggered when there are more than 5 failed log-in attempts overall. Now, add ", /* @__PURE__ */ React.createElement("code", null, "username"), " as Group by Field and an alert will be triggered", " ", /* @__PURE__ */ React.createElement("em", null, "for each ", /* @__PURE__ */ React.createElement("code", null, "username")), " ", "with more than 5 failed log-in attempts.")))), /* @__PURE__ */ React.createElement("hr", null), /* @__PURE__ */ React.createElement(
    AggregationConditionsForm,
    {
      eventDefinition,
      validation,
      formattedFields,
      aggregationFunctions,
      onChange: propagateConfigChange
    }
  ));
};
export default AggregationForm;
